import React from 'react';
import { RouterLink } from '../core';

export const Logo = (props: any): JSX.Element => {
  return (
    <RouterLink
      to="/"
      {...props}
      sx={{
        variant: 'a.noUnderline',
        fontSize: [4, 5],
        mt: [-1, -2],
        ...props.sx,
      }}
    >
      sc🌱on
    </RouterLink>
  );
};
